// Shared navigation model, consumed by both the desktop AppShell and the
// mobile shell so every permitted module is reachable on any device.
import {
    LayoutDashboard, Users, Building2, Clock, CalendarDays, FileText,
    Wallet, ShieldCheck, ClipboardList, Briefcase, GraduationCap,
    HeartPulse, Headphones, Package, UserCircle,
    FileSpreadsheet, Gavel, Network, BookOpen,
    Smartphone, Gauge, User as UserIcon, Users2, Inbox, Megaphone, Sparkles, Landmark, Smile, Trophy, Gift, Upload, Fingerprint, Code2, DatabaseZap } from "lucide-react";

export const NAV = [
    {
        section: "My Workspace",
        items: [
            { to: "/me", label: "My Dashboard", icon: LayoutDashboard, key: "my_dashboard" },
            { to: "/me/profile", label: "My Profile", icon: UserIcon, key: "my_profile" },
            { to: "/me/clock-in", label: "Clock In / Out", icon: Smartphone, key: "clock_in" },
            { to: "/me/time", label: "My Leave & OT", icon: FileText, key: "my_time" },
            { to: "/me/payslips", label: "My Payslips", icon: Wallet, key: "my_payslips" },
            { to: "/me/learning", label: "My Learning", icon: GraduationCap, key: "my_learning" },
            { to: "/me/requests", label: "Certificates & Forms", icon: FileSpreadsheet, key: "my_requests" },
            { to: "/me/tickets", label: "Help & Requests", icon: Headphones, key: "my_tickets" },
            { to: "/me/notifications", label: "Notifications", icon: Inbox, key: "notifications" },
            { to: "/ai/assistant", label: "HR Assistant", icon: Sparkles, key: "ai_assistant" },
        ],
    },
    {
        section: "Team",
        items: [
            { to: "/team", label: "My Team", icon: Users2, key: "team" },
        ],
    },
    {
        section: "Overview",
        items: [
            { to: "/dashboard", label: "Executive Dashboard", icon: LayoutDashboard, key: "dashboard" },
            { to: "/analytics", label: "People Analytics", icon: Gauge, key: "people_analytics" },
            { to: "/owner", label: "Owner Overview", icon: Building2, key: "owner_overview" },
        ],
    },
    {
        section: "HR Operations",
        items: [
            { to: "/approvals", label: "Approvals Inbox", icon: Inbox, key: "approvals_inbox" },
            { to: "/hris/employees", label: "Employees", icon: Users, key: "employees" },
            { to: "/hris/organization", label: "Organization", icon: Network, key: "organization" },
            { to: "/timekeeping/attendance", label: "Attendance Review", icon: Clock, key: "attendance" },
            { to: "/timekeeping/shifts", label: "Shifts", icon: Clock, key: "shifts" },
            { to: "/timekeeping/devices", label: "Biometric Terminals", icon: Fingerprint, key: "biometric_devices" },
            { to: "/timekeeping/holidays", label: "Holidays", icon: CalendarDays, key: "holidays_admin" },
            { to: "/hris/document-requests", label: "Document Requests", icon: FileText, key: "document_requests" },
            { to: "/hris/contracts", label: "Contracts", icon: FileSpreadsheet, key: "contracts" },
            { to: "/hris/migration", label: "Data Migration", icon: DatabaseZap, key: "data_migration" },
            { to: "/hris/import", label: "Import Employees", icon: Upload, key: "employee_import" },
            { to: "/timekeeping/leaves", label: "Leaves", icon: FileText, key: "leaves" },
            { to: "/timekeeping/overtime", label: "Overtime", icon: Clock, key: "overtime" },
            { to: "/timekeeping/adjustments", label: "Adjustment Requests", icon: Clock, key: "adjustments" },
        ],
    },
    {
        section: "Payroll & Compliance",
        items: [
            { to: "/payroll/runs", label: "Payroll Runs", icon: Wallet, key: "payroll_runs" },
            { to: "/payroll/control", label: "Payroll Control", icon: Wallet, key: "payroll_control" },
            { to: "/payroll/final-pay", label: "Final Pay", icon: FileSpreadsheet, key: "final_pay" },
            { to: "/payroll/disbursement", label: "Bank Disbursement", icon: Landmark, key: "disbursement" },
            { to: "/payroll/loans", label: "Employee Loans", icon: Wallet, key: "payroll_loans" },
            { to: "/payroll/reports", label: "Reports", icon: FileSpreadsheet, key: "reports_center" },
            { to: "/payroll/bonuses", label: "Bonuses & Commissions", icon: Gift, key: "bonuses" },
            { to: "/compliance/readiness", label: "Compliance Score", icon: Gauge, key: "compliance_readiness" },
            { to: "/compliance/reports", label: "Gov. Reports", icon: ShieldCheck, key: "compliance_reports" },
            { to: "/payroll/settings", label: "Payroll Settings", icon: BookOpen, key: "payroll_settings" },
        ],
    },
    {
        section: "Talent",
        items: [
            { to: "/recruitment", label: "Recruitment", icon: Briefcase, key: "recruitment" },
            { to: "/recruitment/ai-interview", label: "AI Interview", icon: Sparkles, key: "recruitment" },
            { to: "/onboarding", label: "Onboarding", icon: ClipboardList, key: "onboarding" },
            { to: "/offboarding", label: "Offboarding", icon: ClipboardList, key: "offboarding" },
            { to: "/performance", label: "Performance", icon: HeartPulse, key: "performance" },
            { to: "/training", label: "Training", icon: GraduationCap, key: "training" },
            { to: "/learning", label: "Learning & Skills", icon: BookOpen, key: "learning" },
        ],
    },
    {
        section: "Workplace",
        items: [
            { to: "/relations", label: "Employee Relations", icon: Gavel, key: "relations" },
            { to: "/helpdesk", label: "Helpdesk", icon: Headphones, key: "helpdesk" },
            { to: "/benefits", label: "Benefits", icon: HeartPulse, key: "benefits" },
            { to: "/assets", label: "Assets", icon: Package, key: "assets" },
            { to: "/announcements", label: "Announcements", icon: Megaphone, key: "announcements" },
            { to: "/engagement", label: "Engagement", icon: Smile, key: "engagement" },
            { to: "/rewards", label: "Rewards", icon: Trophy, key: "rewards" },
            { to: "/rewards/exchange", label: "Rewards Exchange", icon: Gift, key: "rewards" },
        ],
    },
    {
        section: "Administration",
        items: [
            { to: "/admin/users", label: "Users & Roles", icon: UserCircle, key: "admin_users" },
            { to: "/admin/rbac", label: "Roles & Permissions", icon: ShieldCheck, key: "admin_rbac" },
            { to: "/admin/companies", label: "Companies", icon: Building2, key: "admin_companies" },
            { to: "/admin/audit", label: "Audit Log", icon: FileText, key: "admin_audit" },
            { to: "/admin/automation", label: "Automation", icon: Clock, key: "admin_automation" },
            { to: "/admin/leave-policies", label: "Leave Policies", icon: CalendarDays, key: "admin_leave_policies" },
            { to: "/admin/ai", label: "AI HR Agent", icon: Sparkles, key: "ai_admin" },
            { to: "/admin/sso", label: "Single Sign-On", icon: ShieldCheck, key: "sso" },
            { to: "/admin/api", label: "API Access", icon: Code2, key: "api_access" },
        ],
    },
    {
        section: "Help",
        items: [
            { to: "/manual", label: "User Manual", icon: BookOpen, key: "user_manual" },
        ],
    },
];
